import { createStore } from 'effector';
import { SavedAddress } from './entities';

export const $savedAddresses = createStore<SavedAddress[]>([]);
